'use client';

import { deleteRx } from 'actions/Database';
import { DBRx } from 'db/schema/drugs';
import { useAppDispatch } from 'lib/hooks';
import { removePrescription } from 'slices/prescriptionSlice';
import styles from 'styles/sunfire.forms.module.css';
import WarningCircleIcon from 'components/icons/WarningCircleIcon';
import DeleteIcon from 'components/icons/DeleteIcon';

interface SavedDrugProps {
  drugs: DBRx[];
}

const SavedDrugList = ({ drugs }: SavedDrugProps) => {
  const dispatch = useAppDispatch();

  const handleRemoveDrug = async (drug: DBRx) => {
    await deleteRx(drug);
    dispatch(removePrescription({ ...drug, created_at: null }));
  };

  return (
    <div className={styles.listContainer}>
      <h3>Your Saved Prescriptions ({drugs.length})</h3>

      {drugs.length === 0 ? (
        <div className={styles.emptyList}>
          <WarningCircleIcon size="small" />
          <span>You haven&apos;t saved any prescriptions</span>
        </div>
      ) : (
        <ul className={styles.savedList}>
          {drugs.map((drug) => {
            return (
              <li key={drug.id}>
                <div>
                  <h3>{drug.name}</h3>
                  <p>
                    <b>
                      {drug.quantity}{' '}
                      {drug.form ? `${drug.form.toLowerCase()}s` : ''} per
                      refill
                    </b>
                  </p>
                  <p>Refills last for {drug.frequency} days</p>
                </div>
                <div className={styles.listButton}>
                  <button
                    className="button"
                    onClick={() => handleRemoveDrug(drug)}
                  >
                    <DeleteIcon />
                    Delete
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default SavedDrugList;
